"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CTGGameModeMonte = void 0;
const CTGCard_1 = require("../Logic/CTGCard");
const CTGGameMode_1 = require("./CTGGameMode");
class CTGGameModeMonte extends CTGGameMode_1.CTGGameMode {
    constructor(total_cards, red_cards, cards_to_move_at_a_time, difficulty_mod) {
        super();
        this.total_cards = total_cards;
        this.red_cards = red_cards;
        this.difficulty_mod = difficulty_mod;
        this.cards_to_move_at_a_time = cards_to_move_at_a_time;
        this.interact_on_start = false;
    }
    generate_initial_cards(rand, difficulty) {
        let cards = [];
        for (let i = 0; i < this.red_cards; i++) {
            cards.push(new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Hearts, CTGCard_1.CTGRank.Queen, CTGCard_1.CTGTapRequirement.Must));
        }
        for (let i = this.red_cards; i < this.total_cards; i++) {
            cards.push(new CTGCard_1.CTGCard(CTGCard_1.CTGSuit.Clubs, CTGCard_1.CTGRank.Jack, CTGCard_1.CTGTapRequirement.Dont));
        }
        rand.shuffleArray(cards);
        let rows = Math.ceil(cards.length / 3);
        let row_offset = (4 - rows) / 2;
        for (let i = 0; i < cards.length; i++) {
            if (i % 3 == 0 && (cards.length - i) == 1) {
                cards[i].x = Math.floor(this.fixed_x_position((1.5)));
            }
            else {
                cards[i].x = Math.floor(this.fixed_x_position((i % 3 + 0.5)));
            }
            cards[i].y = Math.floor(this.fixed_y_position(Math.floor(i / 3) + row_offset));
        }
        return cards;
    }
    card_tapped(card) {
        if (card.tap_requirement == CTGCard_1.CTGTapRequirement.Dont) {
            this.lose([card]);
        }
        else {
            card.destroy(true, true, true);
            let new_score = this.score + 1;
            this.set_score(new_score, new_score / this.red_cards);
            if (new_score == this.red_cards) {
                this.win();
            }
        }
    }
    on_start(scene, rand, difficulty) {
        super.on_start(scene, rand, difficulty);
        this.total_swaps = Math.max(1, (1 + difficulty) * this.difficulty_mod * 5);
        scene.time.delayedCall(2000, () => {
            this.cards.forEach(element => {
                element.flip(false, true);
            });
            scene.time.delayedCall(1000, () => {
                this.check_swap(scene, rand, 0);
            });
        });
    }
    check_swap(scene, rand, swap_count) {
        if (swap_count >= this.total_swaps) {
            this.cards.forEach(element => {
                element.set_can_interact(true);
            });
        }
        else {
            let cards_to_shift = rand.getNRandom(this.cards, this.cards_to_move_at_a_time);
            let start_positions = cards_to_shift.map(x => [x.x, x.y]);
            let end_positions = [...start_positions];
            ;
            if (this.cards_to_move_at_a_time == 2) {
                let end = end_positions.shift();
                end_positions.push(end);
            }
            else {
                rand.shuffleArray(end_positions);
                let arrays_equal = true;
                for (let i = 0; i < end_positions.length; i++) {
                    if (start_positions[i][0] != end_positions[i][0] || start_positions[i][1] != end_positions[i][1]) {
                        arrays_equal = false;
                        break;
                    }
                }
                if (arrays_equal) {
                    let end = end_positions.shift();
                    end_positions.push(end);
                }
            }
            // If swap time is too long, it gets harder.
            const swap_time = Math.min(2000, 5000 / this.total_swaps);
            const tween = scene.tweens.addCounter({
                from: 0,
                to: 1,
                duration: swap_time,
                ease: 'Quad.easeInOut',
                onUpdate: () => {
                    for (let i = 0; i < cards_to_shift.length; i++) {
                        let card = cards_to_shift[i];
                        card.move((end_positions[i][0] - start_positions[i][0]) * tween.getValue() + start_positions[i][0], (end_positions[i][1] - start_positions[i][1]) * tween.getValue() + start_positions[i][1]);
                    }
                },
                onComplete: () => {
                    this.check_swap(scene, rand, swap_count + 1);
                }
            });
        }
    }
    card_destroyed(card) { }
    cards_generated(cards) { }
    time_ran_out() { }
    update_game(scene, now, delta, difficulty, mx, my, mdown) { }
}
exports.CTGGameModeMonte = CTGGameModeMonte;
